<br>
<div class="container header">
  <h3 class="header__title">Project Sampling</h3>
  <form-factory class="input-switch input-switch--inline" [formGroup]="activeFormGroup.formGroup" [model]="activeFormGroup.models[0]"></form-factory>
</div>
<p>
  Defines the proportion of chases sent to each overread stage, per compliance bucket. Each bucket is configured independently.
</p>
<br>
<div class="container flex-gap">
  <div class="grid">
    <div class="container grid__header">
      <p>Overread I</p>
    </div>
    <div class="container justify-center">
      <p>Compliant</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Compliant = All numerators are compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <div class="container justify-center">
      <p>Partial Compliant</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Partial Compliant = At least one numerator is medical record compliant at the chase/measure level,  however other numerators are non-compliant for the same chase/measure.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <div class="container justify-center">
      <p>Non-Compliant</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Non-Compliant = At least one numerator is non-compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <div class="container justify-center">
      <p>Exclusion</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Exclusion = Chase/Measure contains an exclusion for the measure in the appropriate timeframe.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <ng-container *ngFor="let control of getControls(formOverread.formGroup); let i = index; trackBy: trackByIndex">
      <div class="container justify-center">
        <form-factory class="input" [formGroup]="formOverread.formGroup" [model]="formOverread.models[i]" (onChange)="onOverreadValueChange()"></form-factory>
      </div>
    </ng-container>
  </div>
  <div class="divisor"></div>
  <div class="grid">
    <div class="container grid__header">
      <p>Overread II</p>
    </div>
    <div class="container justify-center">
      <p>Compliant</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Compliant = All numerators are compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <div class="container justify-center">
      <p>Partial Compliant</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Partial Compliant = At least one numerator is medical record compliant at the chase/measure level,  however other numerators are non-compliant for the same chase/measure.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <div class="container justify-center">
      <p>Non-Compliant</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Non-Compliant = At least one numerator is non-compliant for the chase/measure.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <div class="container justify-center">
      <p>Exclusion</p>
      <div class="icon">
        <app-icon iconStyle="fal" iconName="info-circle" [pTooltip]="'Exclusion = Chase/Measure contains an exclusion for the measure in the appropriate timeframe.'" [tooltipPosition]="'top'"></app-icon>
      </div>
    </div>
    <ng-container *ngFor="let control of getControls(formOverread2.formGroup); let i = index; trackBy: trackByIndex">
      <div class="container justify-center">
        <form-factory class="input" [formGroup]="formOverread2.formGroup" [model]="formOverread2.models[i]" (onChange)="onOverreadValueChange()"></form-factory>
      </div>
    </ng-container>
  </div>
</div>
